import ValidationFormFieldComponent from "./validation-form-field/ValidationFormField.component";

export default function MainComponent(props){
    return (
        <>
            <ValidationFormFieldComponent />
        </>
    );
}